import { getQuotaStatus, isDepletedCreditsStatus, isLowCreditsStatus } from './operations';
import type { Quota, QuotaOperationInfo } from './types';

/**
 * Create QuotaOperationInfo from raw Quota data
 */
export const createQuotaOperationInfo = (quota: Quota, options: { isLow?: boolean } = {}): QuotaOperationInfo => {
  const status = getQuotaStatus(quota.remaining, quota.total);

  return {
    remaining: quota.remaining,
    total: quota.total,
    used: quota.used,
    status,
    isLow: options.isLow ?? isLowCreditsStatus(status),
    isDepleted: isDepletedCreditsStatus(status),
  };
};
